import _createForOfIteratorHelper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { isDate } from './internal/utils.js';
import CalDate from 'caldate';
var CalEvent = /*#__PURE__*/function () {
  /**
   * @param {object|Date} opts
   * @param {string} opts.fn function type
   * @param {number} [opts.day]
   * @param {number} [opts.month]
   * @param {number} [opts.year]
   * @param {number} [opts.offset]
   * @param {boolean} [opts.substitute]
   */
  function CalEvent(opts) {
    _classCallCheck(this, CalEvent);
    opts = opts || {};
    this.substitute = opts.substitute;
    this.opts = opts;
    this.offset = opts.offset;
    this.dates = [];
    this.active = undefined; // active props from prior to rule
    if (isDate(opts)) {
      this.opts = new CalDate(opts);
    }
  }

  /**
   * @param {number} year
   * @returns {this}
   */
  _createClass(CalEvent, [{
    key: "inYear",
    value: function inYear(year) {
      var d = new CalDate(this.opts).setOffset(this.offset);
      if (!(d.year && d.year !== year)) {
        d.year = year;
        this.dates.push(d);
      }
      return this;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.dates = [];
    }

    /**
     * @param {CalEvent} calEvent
     * @returns {boolean}
     */
  }, {
    key: "isEqualDate",
    value: function isEqualDate(calEvent) {
      var res = false;
      var _iterator = _createForOfIteratorHelper(this.dates),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var thisDate = _step.value;
          var _iterator2 = _createForOfIteratorHelper(calEvent.dates),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var date = _step2.value;
              res |= thisDate.isEqualDate(date);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return !!res;
    }

    /**
     * Filter out disabled dates
     * @param {number} year
     * @param {number} month
     * @returns {this}
     */
  }, {
    key: "filterDisabled",
    value: function filterDisabled(year, month) {
      if (!year) {
        return this;
      }
      this.dates = this.dates.filter(function (date) {
        var disable = month ? date.year === year && date.month === month : date.year === year;
        return !disable;
      });
      return this;
    }

    /**
     * @param {number} year - year to filter
     * @param {object[]} active - definition of active ranges `{from: {Date}, [to]: {Date}}`
     * @return {this} for chaining
     */
  }, {
    key: "filterActive",
    value: function filterActive(year) {
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.active;
      this.dates = this.dates.filter(function (date) {
        if (!date._filter && isActive(date, year, active)) {
          return date;
        }
      });
      return this;
    }

    /**
     * @param {object} active
     * @param {Date} [active.from ]
     * @param {Date} [active.to]
     * @returns
     */
  }, {
    key: "setActive",
    value: function setActive(active) {
      var from = active.from,
        to = active.to;
      var pushIt = true;
      this.active = this.active || [];
      if (to && !from) {
        var last = this.active[this.active.length - 1];
        if (last && last.from && !last.to) {
          last.to = to;
          pushIt = false;
        }
      }
      if (pushIt) {
        this.active.push(active);
      }
      return this;
    }

    /**
     * @param {CalEvent} calEvent
     */
  }, {
    key: "push",
    value: function push(calEvent) {
      if (calEvent && Array.isArray(calEvent.dates)) {
        this.dates = this.dates.concat(calEvent.dates);
      }
    }

    /**
     * @param {string} timezone
     * @returns
     */
  }, {
    key: "get",
    value: function get(timezone) {
      var _this = this;
      var arr = this.dates.map(function (date) {
        var cdate = new CalDate(date);
        var o = {
          date: cdate.toString(),
          start: cdate.toTimezone(timezone),
          end: cdate.toEndDate().toTimezone(timezone)
        };
        _this._addSubstitute(date, o);
        return o;
      });
      return arr;
    }
  }, {
    key: "_addSubstitute",
    value: function _addSubstitute(date, obj) {
      if (this.substitute || date.substitute) obj.substitute = true;
    }
  }]);
  return CalEvent;
}();
export { CalEvent as default };
function isActive(date, year, active) {
  if (!active) {
    return date.year === year;
  }
  var _date = date.toDate();
  var _iterator3 = _createForOfIteratorHelper(active),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var a = _step3.value;
      var from = a.from,
        to = a.to;
      if (date.year === year && (from && to && from <= _date && to > _date || from && !to && from <= _date || !from && to && to > _date)) {
        return true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}